import { render, staticRenderFns } from "./cooperationContent.vue?vue&type=template&id=25ffaa1d&scoped=true&"
import script from "./cooperationContent.vue?vue&type=script&lang=js&"
export * from "./cooperationContent.vue?vue&type=script&lang=js&"
import style0 from "./cooperationContent.vue?vue&type=style&index=0&id=25ffaa1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ffaa1d",
  null
  
)

export default component.exports